/* global ShopgateProductDetailsCore, ShopgateCliplister */

/**
 * This ShopgateProductDetailsCore plugin provides the functionality get cliplister videos for products
 * products on and from the customers favourite list.
 * @param  {Object} _core Reference to the ShopgateProductDetailsCore
 * @return {Object} An object with informations about the capabilities of this plugin
 */
var cliplisterPlugin = function (_core, _coreOptions) {
  var initCollapsed = false;
  var pluginUrls = null;
  var shopgateCliplister;

  /**
   * Called before the core is completely initialized
   * @param  {String} callType The type of the function call (products.ui or products.data)
   * @param  {Object} data Useful data {products, coreOptions}
   */
  function _onCoreInit(callType, data) {
    pluginUrls = _core.getComponentUrls('cliplister');

    if (!shopgateCliplister) {
      var shopgateCliplisterConfig = {
        getCodeUrl: pluginUrls.get_cliplister_code,
      };

      shopgateCliplister = new ShopgateCliplister(shopgateCliplisterConfig);
    }
  }

  /**
   * Called when the core has collected data to display a new product
   * @param  {String} callType The type of the function call (products.ui or products.data)
   * @param  {[type]} productData Useful data for this function {is_parent_product, parent_product_id, product, product_attributes, product_input_fields, product_options}
   */
  function _onUpdateProduct(callType, productData) {
    if (callType && callType !== 'products.ui') {
      return false;
    }

    shopgateCliplister.update(productData.product.product);
  }

  var hooks = {
    vendor: 'Shopgate',
    name: 'ShopgateCliplister',
    type: ['products.ui'],
    onCoreInit: _onCoreInit,
    onUpdateProduct: _onUpdateProduct,
  };

  return hooks;
};

if (typeof ShopgateProductDetailsCore === 'object'
  && typeof ShopgateProductDetailsCore.registerPlugin === 'function') {
  if (ShopgateProductDetailsCore.isComponentActive('cliplister')) {
    ShopgateProductDetailsCore.registerPlugin(cliplisterPlugin);
  }
} else {
  console.warn('No instance of "ShopgateProductDetailsCore" found');
}



// WEBPACK FOOTER //
// ./Library/1.0/common/product_details/jquery.shopgate-product-details-cliplister.js